import React from "react";
import { PropTypes } from "prop-types";
import { List, ListItem, TextWithListContainer } from "./TextWithList.styled";
import { Trans, useTranslation } from "react-i18next";

const TextWithList = ({ textAlignRight, twoColumns, ...props }) => {
  const { t } = useTranslation();

  return (
    <TextWithListContainer $textAlignRight={textAlignRight} $twoColumns={twoColumns}>
      <Trans
        t={t}
        i18nKey={props.text}
        components={{
          0: <span />,
          1: <List $twoColumns={twoColumns} />,
          2: <ListItem $twoColumns={twoColumns}></ListItem>,
        }}
      />
    </TextWithListContainer>
  );
};
TextWithList.propTypes = {
  text: PropTypes.any,
  image: PropTypes.any,
  textAlignRight: PropTypes.bool,
  textColor: PropTypes.string,
  HighlightColor: PropTypes.string,
  applyPadding: PropTypes.bool,
  IsBold: PropTypes.bool,
  twoColumns: PropTypes.bool,
};
TextWithList.defaultProps = {
  textAlignRight: false,
  textColor: "white",
  HighlightColor: "thertiary",
};
export default TextWithList;
